import React, { useState, useEffect } from 'react';
import { array, func } from 'prop-types';
import { Grid } from '@nextiva/next-ui-components';

import CreateRoleCard from 'components/CreateRoleCard';
import UserRolesCard from 'components/UserRolesCard';

const UserRoleGrid = ({ onClickRoleCardHandler, roleList: rl }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const roleList = rl.map((r) => ({ ...r }));
    const globalAccountManager = roleList.find(
      (r) => r.role_type === 'SUPER_ADMIN',
    );

    globalAccountManager.name = 'Admin';

    const defaultRoles = roleList.sort((a, b) => {
      if (a.user_defined < b.user_defined) return -1;
      if (a.user_defined > b.user_defined) return 1;
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      return 0;
    });

    setList(defaultRoles);
  }, [rl]);

  const roleCards = list.map((role) => {
    return (
      <Grid
        item
        xs={4}
        key={role.id}
        className="m-user-card-roles-grid__roleCard"
      >
        <UserRolesCard
          role={role}
          onClickRoleCardHandler={onClickRoleCardHandler}
          dataTestId={`${role.name}-role`}
        />
      </Grid>
    );
  });

  return (
    <Grid container className="m-user-card-roles-container">
      {roleCards}
      <Grid item xs={4} className="m-user-card-roles-grid__createRoleCard">
        <CreateRoleCard onClickRoleCardHandler={onClickRoleCardHandler} />
      </Grid>
    </Grid>
  );
};

UserRoleGrid.propTypes = {
  roleList: array.isRequired,
  onClickRoleCardHandler: func.isRequired,
};

export default UserRoleGrid;
